module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-epc-17a7022459dd332efeb2b9c735f35408.png";